<template>
  <div class="pa-0">
    <v-data-table
      :headers="headers"
      :items="items"
      :items-per-page="10"
      :search="search"
      :loading="loading"
      loading-text="Cargando perfiles de acceso..."
      class="modern-table no-border"
      :footer-props="{
        showFirstLastPage: true,
        itemsPerPageOptions: [10, 20, 50],
      }"
    >
      <template v-slot:top>
        <v-sheet color="white" class="px-6 py-4 d-flex align-center border-bottom bg-lightgrey">
          <div class="d-flex align-center">
            <v-avatar size="32" color="primary lighten-5" class="mr-3">
              <v-icon color="primary" x-small>fas fa-user-shield</v-icon>
            </v-avatar>
            <span class="caption font-weight-bold uppercase tracking-widest grey--text">Roles y Niveles de Acceso ({{ items.length }})</span>
          </div>
          <v-spacer></v-spacer>
          <div class="d-flex align-center" style="gap: 16px;">
            <v-text-field
              v-model="search"
              placeholder="Buscar rol..."
              prepend-inner-icon="fas fa-search"
              outlined dense hide-details clearable
              class="modern-search-field"
              style="max-width: 250px;"
            ></v-text-field>
            <v-btn color="primary" :to="`users/role-create-update/-1`" class="shadow-sm rounded-lg text-none px-4">
              <v-icon left small>fas fa-plus</v-icon>
              Nuevo Rol
            </v-btn>
          </div>
        </v-sheet>
      </template>

      <template v-slot:item.name="{ item }">
        <div class="d-flex align-center py-2">
          <v-avatar size="28" color="secondary lighten-5" class="mr-3">
            <v-icon color="secondary" x-small>fas fa-id-badge</v-icon>
          </v-avatar>
          <span class="body-2 font-weight-black primary--text">{{ item.name }}</span>
        </div>
      </template>

      <template v-slot:item.actions="{ item }">
        <div class="d-flex justify-center">
          <v-btn icon small color="primary" class="grey lighten-4 mr-2" :to="`users/role-create-update/${item.id}`">
            <v-icon x-small>fas fa-edit</v-icon>
          </v-btn>
          <v-btn icon small color="error" class="grey lighten-4" v-if="item.name !== 'Administrador'">
            <v-icon x-small>fas fa-trash-alt</v-icon>
          </v-btn>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import {fetchRoles} from '@/api/auth'
import notifications from '../../utils/notifications'

export default {
  name: 'RolesList',
  data() {
    return {
      items: [],
      search: '',
      loading: false,
      headers: [
        { text: 'Nombre del Perfil', align: 'start', value: 'name', class: 'table-header' },
        { text: 'Acciones de Gestión', value: 'actions', align: 'center', class: 'table-header', width: '150px', sortable: false }
      ],
    }
  },
  async created() {
    this.loading = true
    try {
      this.items = await fetchRoles()
    } catch (e) {
      notifications.showError('Error de conexión: ' + e)
    } finally {
      this.loading = false
    }
  }
}
</script>

<style scoped>
.modern-table { background: transparent !important; }
.modern-table.no-border { border: none !important; }

.modern-table >>> thead th {
  background-color: #f8fbfc !important;
  height: 48px !important;
  text-transform: uppercase;
  font-size: 0.7rem !important;
  letter-spacing: 1px;
  font-weight: 900 !important;
  color: #607d8b !important;
}

.modern-table >>> td {
  height: 60px !important;
  border-bottom: 1px solid #f0f3f5 !important;
}

.bg-lightgrey { background-color: #f8fbfc !important; }
.border-bottom { border-bottom: 1px solid rgba(0,0,0,0.06) !important; }
.uppercase { text-transform: uppercase; letter-spacing: 1px; }
.tracking-widest { letter-spacing: 2px; }
.shadow-sm { box-shadow: 0 2px 8px rgba(0,0,0,0.05) !important; }

.modern-search-field >>> .v-input__control >>> .v-input__slot {
  background-color: white !important;
  border-radius: 10px !important;
}
</style>